<template>
  <div class="card addingPopupWindow">
    <font-awesome-icon
      icon="fa-solid fa-check-circle"
      style="color: var(--theme)"
      size="lg"
    />
    <div>
      <div class="info">
        <strong> {{ productName }} </strong>is toegevoegd aan je winkelmand
      </div>
      <router-link
        style="color: var(--theme)"
        :to="{ name: 'cart', params: {} }"
      >
        Ga naar winkelwagen
      </router-link>
    </div>
  </div>
</template>

<script>
import "@/assets/fonts.scss";
import { mapGetters } from "vuex";

export default {
  name: "AddingPopupWindow",
  props: {
    productName: String,
  },
};
</script>

<style lang="scss">
.addingPopupWindow {
  background: #eeeefa;
  padding: 15px 30px;
  position: fixed;
  bottom: 20px;
  right: 20px;
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
  border: 1px solid #ddd;
  color: #333;

  a {
    font-weight: 600;
    color: white;
  }
}
</style>
